import angular from 'angular';
import dayjs from 'dayjs';
import { AncillariesUtilsService } from '../../../../../../shared/ib-web-ancillaries-utils';

@Service('ib-bob-form-module', ['$rootScope', '$filter', 'AncillariesUtilsService', 'AncillariesConstants', 'CurrencyService', 'localStorageService'])
class BobFormTransformer {

    constructor (
        private $rootScope: CommonsRootScope,
        private $filter: angular.IFilterService,
        private AncillariesUtilsService: AncillariesUtilsService,
        private AncillariesConstants: AncillariesConstant,
        private CurrencyService,
        private localStorageService: angular.local.storage.ILocalStorageService) { }



    generateMatchPickUp = (bobInfo:any, pickUpData:any): any => {
        angular.forEach(bobInfo, (info, index) => {
            info.addressReturned = null;
            info.address = null;
            info.complementAddress = null;
            info.pickUpSlot = this.transformArray(pickUpData[index].pickUpDates, info.departure.date, pickUpData[index].timezone);
            info.pickUpSlot = this.setSelectedPickUp(info.pickUpSlot);
        });
        return bobInfo;

    };

    transformArray = (pickUpData:any, date:any, timezone:any): any => {
        let departureDate, pickupDate, sameDay = {}, beforeDay = {}, day, month, year, count = 0;
        angular.forEach(pickUpData, (data) => {
            pickupDate = new Date(data.date);
            day = pickupDate.getDate();
            month = pickupDate.getMonth() + 1;
            year = pickupDate.getFullYear();
            departureDate = dayjs(`${date.year}-${date.monthNumber + 1}-${date.monthDay}`);
            pickupDate = dayjs(`${year}-${month + 1}-${day}`);
            if (departureDate.diff(pickupDate, 'days') === 0) {
                sameDay = data;
                count++;
            } else {
                beforeDay = data;
                count++;
            }
        });
        return {
            sameDay: sameDay,
            beforeDay: beforeDay,
            count: count,
            timezone: timezone
        };
    };

    setSelectedPickUp = (info:any): any => {
        if (info.beforeDay.available === true) {
            info.selectedPickup = info.beforeDay;
            info.selectedSlot = null;
        } else {
            info.selectedPickup = info.sameDay;
            info.selectedSlot = null;
        }
        return info;
    };


    createJsonComplete = (model:any, bobInfo:any): any => {
        let dataSlice: any = {}, passengers, infoPassenger;
        const services = [];
        const frequentFlyer: any = this.localStorageService.get('frequentFlyerBOB');
        const json = {
            pnr: model.pnr,
            email: model.email,
            phone: '+' + model.countryCode + model.phone,
            services: []
        };
        angular.forEach(model.services, (slice, index) => {
            passengers = [];
            dataSlice = {};
            angular.forEach(slice.passengers, (passenger) => {
                infoPassenger = {
                    name: passenger.name,
                    surname: passenger.surname,
                    ticketNumber: passenger.ticketNumber,
                    numBags: passenger.numBags
                };
                if (frequentFlyer) {
                    infoPassenger.frequentFlyerInfo = {
                        number: frequentFlyer.number,
                        topTier: frequentFlyer.topTier,
                        topTierLevel: this.AncillariesConstants.FFLEVELBOB[frequentFlyer.topTier]
                    };
                }
                if (passenger.numBags > 0) {
                    passengers.push(infoPassenger);
                }
            });
            if (passengers.length > 0 && slice.addressReturned !== null && slice.pickUpSlot.selectedPickup !== null) {
                dataSlice.addressInfo = slice.addressReturned;
                dataSlice.passengers = passengers;
                dataSlice.pickUpSlot = {
                    date: slice.pickUpSlot.selectedPickup.date,
                    available: slice.pickUpSlot.selectedPickup.available,
                    from: slice.pickUpSlot.selectedSlot.from,
                    to: slice.pickUpSlot.selectedSlot.to,
                    timeSlot: slice.pickUpSlot.selectedSlot.timeSlot,
                    timezone: slice.pickUpSlot.timezone
                };
                dataSlice.sliceId = bobInfo.slices[index].sliceId;

                services.push(dataSlice);
            }
        });
        json.services = services;

        return json;
    };


    generateUpdateBob = (bobOrder:any, bobResponse:any): any => {

        const updateData = [];
        const sliceIds = [];
        let bags = 0;

        angular.forEach(bobOrder.services, (slice) => {
            sliceIds.push({ sliceId: slice.sliceId });
            angular.forEach(slice.passengers, (passenger) => {
                bags += passenger.numBags;
            });
        });
        const data = {
            slices: sliceIds,
            orderId: bobResponse.id,
            status: bobResponse.status.toUpperCase(),
            type: 'INTEGRATED_BOB',
            bags: bags
        };

        updateData.push(data);
        return updateData;
    };

    generateModelStorage = (model:any, storage:any): any => {
        if (storage.email) {
            model.email = storage.email;
        }
        if (storage.phone) {
            model.phone = storage.phone;
        }
        if (storage.countryCode) {
            model.countryCode = storage.countryCode;
        }
        if (storage.priceTotal) {
            model.priceTotal = storage.priceTotal;
        }
        if (storage.totalFormatted) {
            model.totalFormatted = storage.totalFormatted;
        }
        if (storage.numBagsTotal) {
            model.numBagsTotal = storage.numBagsTotal;
        }
        angular.forEach(model.services, (service, index) => {
            if (service.sliceId === storage.services[index].sliceId) {
                angular.forEach(service.passengers, (passenger, passengerIndex) => {
                    if (passenger.name === storage.services[index].passengers[passengerIndex].name &&
                        passenger.surname === storage.services[index].passengers[passengerIndex].surname &&
                        passenger.ticketNumber === storage.services[index].passengers[passengerIndex].ticketNumber) {

                        passenger.numBags = storage.services[index].passengers[passengerIndex].numBags;
                        passenger.priceTotalBags = storage.services[index].passengers[passengerIndex].priceTotalBags;
                    }
                });
                service.baggage = storage.services[index].baggage;
                service.priceTotal = storage.services[index].priceTotal;
                service.addressReturned = storage.services[index].addressReturned
                    ? storage.services[index].addressReturned : null;
                service.address = storage.services[index].address
                    ? storage.services[index].address : null;
                service.complementAddress = storage.services[index].complementAddress
                    ? storage.services[index].complementAddress : null;
                if (service.pickUpSlot.count === storage.services[index].pickUpSlot.count) {
                    if (angular.equals(service.pickUpSlot.sameDay, storage.services[index].pickUpSlot.sameDay) &&
                        angular.equals(service.pickUpSlot.beforeDay, storage.services[index].pickUpSlot.beforeDay)) {
                        service.pickUpSlot.selectedPickup = storage.services[index].pickUpSlot.selectedPickup;
                        service.pickUpSlot.selectedSlot = storage.services[index].pickUpSlot.selectedSlot;
                    }
                }
            }
        });

        return model;
    };
}